import {Component, Inject} from "@angular/core";
import {Aircraft} from "../aircraft";;
import {Router} from "@angular/router";

@Component({
	selector: "sharing-info",
	template: `
		<modal class="sharingInfoModal" *ngIf="showSharingInfoModal" (close)="showSharingInfoModal=false">
			<header class="modal_header text-center">
				<h2>Manage Sharing or Transfer Aircraft?</h2>
			</header>
			<div class="devicemessage">
				<b>If this is your aircraft, </b>
				you can use the "Manage Sharing" page to provide limited access to this aircraft with another user. This will not transfer the aircraft and can be revoked at any time.
				<br><br>
				<b>If this aircraft is being set up for another user </b>
				and you will be transferring this aircraft, you will want to use the "Aircraft Transfer" page.
			</div>
			<div class="modal_footer text-center">
				<button class="button button-secondary button-margin" type="button"
						[routerLink]="'/aircraft/'+ aircraft.id + '/share-settings'">
					Manage Sharing
				</button>
				<button class="button button-secondary button-margin" type="button"
						[routerLink]="'/transfer'">
					Transfer Aircraft
				</button>
			</div>
		</modal>
	`,
})
export class SharingInfoComponent {
	showSharingInfoModal: boolean;
	aircraft: Aircraft;
	isOemUser: boolean;
	isDealerUser: boolean;

	constructor(
		@Inject("isOemUser") isOemUser: boolean,
		@Inject("isDealerUser") isDealerUser: boolean,
		private router: Router,
	) {
		this.isOemUser = isOemUser;
		this.isDealerUser = isDealerUser;
	}

	open(aircraft: Aircraft) {
		this.aircraft = aircraft;
		if (this.isOemUser || this.isDealerUser) {
			this.showSharingInfoModal = true;
		} else {
			this.router.navigate(["/aircraft/" + this.aircraft.id + "/share-settings"]);
		}
	}
}
